import React from 'react'
import {useTranslation} from 'react-i18next'
import {formatNumber} from '../../utils/formatNumber.ts'

type CreatedVsPrintedChartProps = {
    series: Array<{ label: string; created: number; printed: number; createdHeightPx: number; printedHeightPx: number }>
    yAxisTicks: string[]
}

export const CreatedVsPrintedChart: React.FC<CreatedVsPrintedChartProps> = ({ series, yAxisTicks }) => {
    const {t} = useTranslation('dashboard')
    return (
    <div className="bg-white rounded-2xl p-5 border border-neutralBlack-200 shadow-sm flex flex-col gap-[18px]">
        <div className="flex items-center gap-4 flex-wrap">
            <span className="text-[15px] font-semibold tracking-tight text-neutralBlack-900">{t('metrics.createdVsPrintedTitle')}</span>
            <span className="flex-1 min-w-1.5" />
            <span className="inline-flex items-center gap-1.5 text-xs text-neutralBlack-800">
                <span className="w-[9px] h-[9px] rounded-[3px]" style={{ background: '#E8A200' }} />
                {t('metrics.legendCreated')}
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs text-neutralBlack-800">
                <span className="w-[9px] h-[9px] rounded-[3px]" style={{ background: '#18AE60' }} />
                {t('metrics.legendPrinted')}
            </span>
        </div>
        <div className="flex gap-2.5" style={{ height: 180 }}>
            <div className="w-12 flex-none flex flex-col justify-between items-end" style={{ paddingBottom: 26 }}>
                {yAxisTicks.map((t, i) => (
                    <span key={i} className="text-[10.5px] leading-none text-neutralBlack-400 whitespace-nowrap">{t}</span>
                ))}
            </div>
            <div className="flex-1 min-w-0 flex items-end gap-2.5 relative">
                <div className="absolute inset-x-0 top-0 flex flex-col justify-between pointer-events-none" style={{ bottom: 26 }}>
                    {yAxisTicks.map((_, i) => (
                        <span key={i} className="h-px bg-neutralBlack-100" />
                    ))}
                </div>
                {series.map((point) => (
                    <div key={point.label} className="relative z-10 flex-1 min-w-0 flex flex-col items-center gap-2">
                        <div className="flex-1 w-full flex items-end justify-center gap-[3px]">
                            <span title={t('metrics.tooltipCreated', {n: formatNumber(point.created)})} className="w-[11px] rounded-t" style={{ background: '#E8A200', height: `${point.createdHeightPx}px` }} />
                            <span title={t('metrics.tooltipPrinted', {n: formatNumber(point.printed)})} className="w-[11px] rounded-t" style={{ background: '#18AE60', height: `${point.printedHeightPx}px` }} />
                        </div>
                        <span className="text-[11px] text-neutralBlack-600">{point.label}</span>
                    </div>
                ))}
            </div>
        </div>
    </div>
    )
}
